import { getTodaysDate, getPastDateByMonth} from "./utils"
import ErrorFormatter from "./ErrorFormatter"
class MetricsApi {
    
    todaysDate() {
        return new Date().toJSON().split("T")[0]
    }

    getPastDateByMonth(pastMonth) {
        const start = new Date()
        start.setMonth(start.getMonth() - pastMonth)
        return start.toJSON().split("T")[0]
    }

    formatQueryParams({startDate, endDate, branches, cached, tags, teamUUID}) {
        const queryParams = {
            startDate: startDate || getPastDateByMonth(1),
            endDate: endDate || getTodaysDate(),
            branches: branches || "*",
            cache: cached || false
        }
        if(tags) queryParams.tags = tags
        if(teamUUID) queryParams.teamUUID = teamUUID
        return queryParams
    }
    
    async getMetrics(queryParams) {
        const formattedQueryParams = this.formatQueryParams(queryParams)
        const query = Object.keys(formattedQueryParams).map((key) => key+"="+formattedQueryParams[key]).join("&") 
        try {
            return await window.meterian.metrics.get(query)
        } catch(e) {
            const formattedError = new ErrorFormatter(e).format()
            if(!e) throw new Error({message: "Something went wrong"})
            throw formattedError
        }
    }

}

export default MetricsApi